var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReddit = function SvgReddit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4500",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.335 8a1.17 1.17 0 0 0-1.976-.801c-.911-.62-1.981-.96-3.08-.985l.518-2.495 1.712.36a.8.8 0 1 0 .106-.49l-1.96-.391a.25.25 0 0 0-.297.188v.004l-.59 2.776a5.73 5.73 0 0 0-3.12.985 1.167 1.167 0 1 0-1.6 1.702c.092.086.197.16.315.21a3 3 0 0 0 0 .353c0 1.791 2.088 3.25 4.663 3.25s4.663-1.457 4.663-3.25a3 3 0 0 0 0-.352c.402-.201.654-.615.646-1.064m-8 .801a.803.803 0 0 1 1.603 0c0 .442-.36.802-.801.802a.804.804 0 0 1-.802-.802m4.648 2.2a3.07 3.07 0 0 1-1.977.616 3.07 3.07 0 0 1-1.977-.616.216.216 0 0 1 .304-.304 2.6 2.6 0 0 0 1.665.503 2.63 2.63 0 0 0 1.672-.488.225.225 0 0 1 .316.004.225.225 0 0 1-.003.317zm-.144-1.37a.803.803 0 0 1-.801-.802c0-.441.36-.801.801-.801s.802.36.802.801a.8.8 0 0 1-.768.831h-.04z"
  })));
};
export default SvgReddit;